import React from 'react'
import Buynow from '../Components/buynow/Buynow'

function BuynowPage() {
  return (
    <Buynow/>
  )
}

export default BuynowPage